<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen w-screen self-center bg-flow"></div>
<div class="w-screen h-screen flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t;prefix:'auth'">
    <div class="md:w-[350px] grid pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'../assets/logo.png'" />
        </div>
        <div class="px-[25px] md:px-0">
               <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('password')+ '*'"
                customContainerlass="!w-full md:!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0" [(ngModel)]="password" id="password-change"
                [type]="showPassword ? 'text':'password'" [value]="password">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('confirmPassword')+ '*'"
                customContainerlass="!w-full md:!w-full border-b-[2px] border-primary mb-8"
                customInputClass="border-0" [(ngModel)]="confirmPassword" id="conf-password-change"
                [type]="showPassword ? 'text':'password'" [value]="confirmPassword">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <div (click)="backToLogin()"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
                {{t('backToLogin')}}</div>
        </div>
        <div class="ml-auto w-full px-[25px] md:px-0" [ngClass]="{'opacity-30 pointer-events-none': !password || password !== confirmPassword}">
            <std-button (click)="changePassword(t)" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('chagePassword')}}</std-button>
        </div>
    </div>
</div>